// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ✅ OuvrierPage - Style pro (ShemsPaie) */

/* ── Header subtitle ── */
.op-page-subtitle {
  font-size: 0.82rem;
  color: #999;
  margin-top: 2px;
  font-weight: 500;
}
.op-subtitle-count {
  font-weight: 700;
  color: #6d4e36;
}
.op-subtitle-warn {
  color: #b71c1c;
  font-weight: 600;
}

/* ── Hero Search Bar ── */
.op-search-hero {
  margin-bottom: 0;
}
.op-search-hero .input-group {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(109, 78, 54, 0.12);
  border: 2px solid rgba(109, 78, 54, 0.25);
}
.op-search-icon {
  background: rgba(109, 78, 54, 0.08);
  border: none;
  color: #6d4e36;
  font-size: 1rem;
}
.op-search-input {
  border: none;
  font-size: 1rem;
  padding: 0.6rem 0.9rem;
  box-shadow: none !important;
}
.op-search-input:focus {
  outline: none;
  box-shadow: none !important;
}
.op-search-hero .input-group:focus-within {
  border-color: #6d4e36;
  box-shadow: 0 2px 16px rgba(109, 78, 54, 0.2);
}

/* ── Bloqué cycle button ── */
.op-bloque-toggle {
  min-width: 92px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

/* ── Result badge ── */
.op-result-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(109, 78, 54, 0.1);
  color: #6d4e36;
  font-weight: 700;
  font-size: 0.78rem;
  border-radius: 20px;
  padding: 4px 12px;
  white-space: nowrap;
}

/* ── Action buttons column ── */
.op-action-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  flex-shrink: 0;
}
.op-more-btn {
  border-radius: 8px !important;
}
.op-more-btn::after {
  display: none !important;
}
.op-action-menu {
  border-radius: 12px;
  border: 1.5px solid rgba(109, 78, 54, 0.2);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  min-width: 190px;
  padding: 6px;
}
.op-action-menu .dropdown-item {
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background 0.12s;
}
.op-action-menu .dropdown-item:hover {
  background: rgba(109, 78, 54, 0.08);
  color: #6d4e36;
}
.op-action-menu .dropdown-divider {
  margin: 4px 6px;
}

/* ── STC badge in table ── */
.op-stc-badge {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

/* ── Mini badge (RIB, etc.) ── */
.op-mini-badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;
}

/* ── Name cell ── */
.op-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}
.op-name-text {
  font-weight: 600;
  color: #3a2a1a;
}
.op-name-locked {
  color: #b71c1c;
  font-size: 0.7rem;
  opacity: 0.7;
}

/* ── Qualification truncate ── */
.op-qual-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 160px;
}

/* ── Chantier chip ── */
.op-chantier-chip {
  display: inline-block;
  background: rgba(109, 78, 54, 0.1);
  color: #6d4e36;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

/* ── Salary cell ── */
.op-salary-cell small {
  font-size: 0.7rem;
  color: #888;
  margin-left: 2px;
}

/* ── RIB ── */
.op-rib-text {
  font-family: monospace;
  font-size: 0.82rem;
  letter-spacing: 0.02em;
}

/* ── Dernier STC montant ── */
.op-stc-amount {
  font-weight: 700;
  color: #6f42c1;
}
.op-stc-amount small {
  font-size: 0.7rem;
  color: #888;
  margin-left: 2px;
  font-weight: 400;
}

/* ── Bloqué row ── */
.op-row-bloque td {
  opacity: 0.6;
}
.op-name-locked {
  color: #b71c1c;
  font-size: 0.65rem;
  opacity: 0.6;
  flex-shrink: 0;
}

/* ── Pagination ── */
.op-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid rgba(109,78,54,0.1);
  background: #faf7f4;
}
.op-pag-btn {
  background: #fff;
  border: 1.5px solid rgba(109,78,54,0.3);
  color: #6d4e36;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.12s;
}
.op-pag-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.op-pag-btn:not(:disabled):hover {
  background: rgba(109,78,54,0.1);
}
.op-pag-info {
  font-size: 0.82rem;
  color: #888;
}

/* ── Empty state ── */
.op-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  color: #bbb;
  gap: 12px;
}
.op-empty-icon {
  font-size: 2.5rem;
  opacity: 0.3;
}

/* ── Table header clean ── */
.op-table-wrap .table thead th {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
  color: #6d4e36;
  background: #faf7f4;
  border-bottom: 2px solid rgba(109, 78, 54, 0.2);
  white-space: nowrap;
  padding: 10px 12px;
}
.op-table-wrap .table tbody td {
  padding: 10px 12px;
  vertical-align: middle;
  border-color: rgba(109, 78, 54, 0.08);
}
.op-table-wrap .table tbody tr:hover td {
  background: rgba(109, 78, 54, 0.04) !important;
}
.op-table-wrap .table-bordered {
  border: none;
}
.op-table-wrap .table {
  min-width: 900px;
}

.op-page h2 {
    color: var(--color-dark-brown);
  }
  
  .op-badge {
    padding: 6px 10px;
    border-radius: 12px;
    font-weight: 900;
    display: inline-flex;
    align-items: center;
  }
  
  .op-count-badge {
    padding: 10px 12px;
    border-radius: 12px;
    background: rgba(109, 78, 54, 0.85) !important;
  }
  
  /* KPI */
  .op-kpi-card {
    border-radius: 16px;
    border: 2px solid rgba(109, 78, 54, 0.20);
    background: var(--color-beige);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
  }
  
  .op-kpi-ok {
    background: linear-gradient(135deg, rgba(46, 125, 50, 0.18), rgba(245, 245, 219, 0.9));
  }
  
  .op-kpi-warn {
    background: linear-gradient(135deg, rgba(245, 124, 0, 0.18), rgba(245, 245, 219, 0.9));
  }
  
  .op-kpi-info {
    background: linear-gradient(135deg, rgba(21, 101, 192, 0.16), rgba(245, 245, 219, 0.9));
  }
  
  .op-kpi-title {
    font-weight: 900;
    color: var(--color-dark-brown);
  }
  
  .op-kpi-value {
    font-size: 28px;
    font-weight: 1000;
    margin-top: 4px;
    color: var(--color-dark-brown);
  }
  
  /* Filter Card */
  .op-filter-card {
    border-radius: 16px;
    border: 2px solid rgba(109, 78, 54, 0.25);
    background: #fff;
  }
  
  /* Table wrap */
  .op-table-wrap {
    border-radius: 16px;
    border: 2px solid rgba(109, 78, 54, 0.20);
    overflow: hidden;
    background: #fff;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
  }
  
  /* react-select */
  .op-select .react-select__control {
    border-radius: 12px;
    border: 1px solid rgba(109, 78, 54, 0.45);
    box-shadow: none;
  }
  
  .op-select .react-select__control:hover {
    border-color: rgba(139, 94, 60, 0.8);
  }
  
  .op-select .react-select__multi-value {
    border-radius: 10px;
    border: 1px solid rgba(109, 78, 54, 0.25);
    background: rgba(245, 245, 219, 0.85);
  }
  
  .op-select .react-select__multi-value__label {
    font-weight: 800;
    color: var(--color-dark-brown);
  }
  .op-table-wrap {
    width: 100%;
    overflow-x: auto;
  }
  
  .op-table-wrap .table {
    min-width: 1100px; /* ajuste si besoin */
  }`, "",{"version":3,"sources":["webpack://./src/styles/OuvrierPage.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;IACI,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA,QAAQ;EACR;IACE,mBAAmB;IACnB,yCAAyC;IACzC,8BAA8B;IAC9B,0CAA0C;EAC5C;;EAEA;IACE,sFAAsF;EACxF;;EAEA;IACE,sFAAsF;EACxF;;EAEA;IACE,uFAAuF;EACzF;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,8BAA8B;EAChC;;EAEA,gBAAgB;EAChB;IACE,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;IACnB,yCAAyC;IACzC,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB,EAAE,qBAAqB;EAC1C","sourcesContent":["/* ✅ OuvrierPage - Style pro (ShemsPaie) */\r\n\r\n/* ── Header subtitle ── */\r\n.op-page-subtitle {\r\n  font-size: 0.82rem;\r\n  color: #999;\r\n  margin-top: 2px;\r\n  font-weight: 500;\r\n}\r\n.op-subtitle-count {\r\n  font-weight: 700;\r\n  color: #6d4e36;\r\n}\r\n.op-subtitle-warn {\r\n  color: #b71c1c;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ── Hero Search Bar ── */\r\n.op-search-hero {\r\n  margin-bottom: 0;\r\n}\r\n.op-search-hero .input-group {\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 12px rgba(109, 78, 54, 0.12);\r\n  border: 2px solid rgba(109, 78, 54, 0.25);\r\n}\r\n.op-search-icon {\r\n  background: rgba(109, 78, 54, 0.08);\r\n  border: none;\r\n  color: #6d4e36;\r\n  font-size: 1rem;\r\n}\r\n.op-search-input {\r\n  border: none;\r\n  font-size: 1rem;\r\n  padding: 0.6rem 0.9rem;\r\n  box-shadow: none !important;\r\n}\r\n.op-search-input:focus {\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n.op-search-hero .input-group:focus-within {\r\n  border-color: #6d4e36;\r\n  box-shadow: 0 2px 16px rgba(109, 78, 54, 0.2);\r\n}\r\n\r\n/* ── Bloqué cycle button ── */\r\n.op-bloque-toggle {\r\n  min-width: 92px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n/* ── Result badge ── */\r\n.op-result-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: rgba(109, 78, 54, 0.1);\r\n  color: #6d4e36;\r\n  font-weight: 700;\r\n  font-size: 0.78rem;\r\n  border-radius: 20px;\r\n  padding: 4px 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Action buttons column ── */\r\n.op-action-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px !important;\r\n  flex-shrink: 0;\r\n}\r\n.op-more-btn {\r\n  border-radius: 8px !important;\r\n}\r\n.op-more-btn::after {\r\n  display: none !important;\r\n}\r\n.op-action-menu {\r\n  border-radius: 12px;\r\n  border: 1.5px solid rgba(109, 78, 54, 0.2);\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n  min-width: 190px;\r\n  padding: 6px;\r\n}\r\n.op-action-menu .dropdown-item {\r\n  border-radius: 8px;\r\n  padding: 7px 12px;\r\n  font-size: 0.88rem;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: background 0.12s;\r\n}\r\n.op-action-menu .dropdown-item:hover {\r\n  background: rgba(109, 78, 54, 0.08);\r\n  color: #6d4e36;\r\n}\r\n.op-action-menu .dropdown-divider {\r\n  margin: 4px 6px;\r\n}\r\n\r\n/* ── STC badge in table ── */\r\n.op-stc-badge {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  padding: 4px 8px;\r\n  border-radius: 20px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n/* ── Mini badge (RIB, etc.) ── */\r\n.op-mini-badge {\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  padding: 3px 8px;\r\n  border-radius: 20px;\r\n}\r\n\r\n/* ── Name cell ── */\r\n.op-name-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.op-name-text {\r\n  font-weight: 600;\r\n  color: #3a2a1a;\r\n}\r\n.op-name-locked {\r\n  color: #b71c1c;\r\n  font-size: 0.7rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n/* ── Qualification truncate ── */\r\n.op-qual-text {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  max-width: 160px;\r\n}\r\n\r\n/* ── Chantier chip ── */\r\n.op-chantier-chip {\r\n  display: inline-block;\r\n  background: rgba(109, 78, 54, 0.1);\r\n  color: #6d4e36;\r\n  border-radius: 20px;\r\n  padding: 2px 10px;\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Salary cell ── */\r\n.op-salary-cell small {\r\n  font-size: 0.7rem;\r\n  color: #888;\r\n  margin-left: 2px;\r\n}\r\n\r\n/* ── RIB ── */\r\n.op-rib-text {\r\n  font-family: monospace;\r\n  font-size: 0.82rem;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n/* ── Dernier STC montant ── */\r\n.op-stc-amount {\r\n  font-weight: 700;\r\n  color: #6f42c1;\r\n}\r\n.op-stc-amount small {\r\n  font-size: 0.7rem;\r\n  color: #888;\r\n  margin-left: 2px;\r\n  font-weight: 400;\r\n}\r\n\r\n/* ── Bloqué row ── */\r\n.op-row-bloque td {\r\n  opacity: 0.6;\r\n}\r\n.op-name-locked {\r\n  color: #b71c1c;\r\n  font-size: 0.65rem;\r\n  opacity: 0.6;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Pagination ── */\r\n.op-pagination-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  border-top: 1px solid rgba(109,78,54,0.1);\r\n  background: #faf7f4;\r\n}\r\n.op-pag-btn {\r\n  background: #fff;\r\n  border: 1.5px solid rgba(109,78,54,0.3);\r\n  color: #6d4e36;\r\n  border-radius: 8px;\r\n  width: 32px;\r\n  height: 32px;\r\n  font-size: 1.1rem;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  transition: background 0.12s;\r\n}\r\n.op-pag-btn:disabled {\r\n  opacity: 0.3;\r\n  cursor: default;\r\n}\r\n.op-pag-btn:not(:disabled):hover {\r\n  background: rgba(109,78,54,0.1);\r\n}\r\n.op-pag-info {\r\n  font-size: 0.82rem;\r\n  color: #888;\r\n}\r\n\r\n/* ── Empty state ── */\r\n.op-empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding: 48px 0;\r\n  color: #bbb;\r\n  gap: 12px;\r\n}\r\n.op-empty-icon {\r\n  font-size: 2.5rem;\r\n  opacity: 0.3;\r\n}\r\n\r\n/* ── Table header clean ── */\r\n.op-table-wrap .table thead th {\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  font-weight: 700;\r\n  color: #6d4e36;\r\n  background: #faf7f4;\r\n  border-bottom: 2px solid rgba(109, 78, 54, 0.2);\r\n  white-space: nowrap;\r\n  padding: 10px 12px;\r\n}\r\n.op-table-wrap .table tbody td {\r\n  padding: 10px 12px;\r\n  vertical-align: middle;\r\n  border-color: rgba(109, 78, 54, 0.08);\r\n}\r\n.op-table-wrap .table tbody tr:hover td {\r\n  background: rgba(109, 78, 54, 0.04) !important;\r\n}\r\n.op-table-wrap .table-bordered {\r\n  border: none;\r\n}\r\n.op-table-wrap .table {\r\n  min-width: 900px;\r\n}\r\n\r\n.op-page h2 {\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  .op-badge {\r\n    padding: 6px 10px;\r\n    border-radius: 12px;\r\n    font-weight: 900;\r\n    display: inline-flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .op-count-badge {\r\n    padding: 10px 12px;\r\n    border-radius: 12px;\r\n    background: rgba(109, 78, 54, 0.85) !important;\r\n  }\r\n  \r\n  /* KPI */\r\n  .op-kpi-card {\r\n    border-radius: 16px;\r\n    border: 2px solid rgba(109, 78, 54, 0.20);\r\n    background: var(--color-beige);\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);\r\n  }\r\n  \r\n  .op-kpi-ok {\r\n    background: linear-gradient(135deg, rgba(46, 125, 50, 0.18), rgba(245, 245, 219, 0.9));\r\n  }\r\n  \r\n  .op-kpi-warn {\r\n    background: linear-gradient(135deg, rgba(245, 124, 0, 0.18), rgba(245, 245, 219, 0.9));\r\n  }\r\n  \r\n  .op-kpi-info {\r\n    background: linear-gradient(135deg, rgba(21, 101, 192, 0.16), rgba(245, 245, 219, 0.9));\r\n  }\r\n  \r\n  .op-kpi-title {\r\n    font-weight: 900;\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  .op-kpi-value {\r\n    font-size: 28px;\r\n    font-weight: 1000;\r\n    margin-top: 4px;\r\n    color: var(--color-dark-brown);\r\n  }\r\n  \r\n  /* Filter Card */\r\n  .op-filter-card {\r\n    border-radius: 16px;\r\n    border: 2px solid rgba(109, 78, 54, 0.25);\r\n    background: #fff;\r\n  }\r\n  \r\n  /* Table wrap */\r\n  .op-table-wrap {\r\n    border-radius: 16px;\r\n    border: 2px solid rgba(109, 78, 54, 0.20);\r\n    overflow: hidden;\r\n    background: #fff;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);\r\n  }\r\n  \r\n  /* react-select */\r\n  .op-select .react-select__control {\r\n    border-radius: 12px;\r\n    border: 1px solid rgba(109, 78, 54, 0.45);\r\n    box-shadow: none;\r\n  }\r\n  \r\n  .op-select .react-select__control:hover {\r\n    border-color: rgba(139, 94, 60, 0.8);\r\n  }\r\n  \r\n  .op-select .react-select__multi-value {\r\n    border-radius: 10px;\r\n    border: 1px solid rgba(109, 78, 54, 0.25);\r\n    background: rgba(245, 245, 219, 0.85);\r\n  }\r\n  \r\n  .op-select .react-select__multi-value__label {\r\n    font-weight: 800;\r\n    color: var(--color-dark-brown);\r\n  }\r\n  .op-table-wrap {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n  }\r\n  \r\n  .op-table-wrap .table {\r\n    min-width: 1100px; /* ajuste si besoin */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
